import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "../Components/Layout/Body/index";
import { Login } from "../Pages/Login";

import { Home } from "../Pages/Home";
import ProtectedRoute from "../RouterPath/protectedRoute"; // Import ProtectedRoute

const RoutePath = ({ isDarkTheme }) => {
  useEffect(() => {
    const handleInvalidToken = (e) => {
      if (e.key === "apptoken" && e.oldValue && !e.newValue) {
      }
    };

    window.addEventListener("storage", handleInvalidToken);
    return function cleanup() {
      window.removeEventListener("storage", handleInvalidToken);
    };
  }, []);

  return (
    <div className="App">
      <Routes>
        {/* Public Routes without Layout (no header/menu) */}
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Login />} />

        <Route element={<Layout isDarkTheme={isDarkTheme} />}>
          {/* Public Routes with Layout */}

          {/* <Route path="/landing" element={<LandingPage />} /> */}

          {/* <Route path="/enquiry" element={<Enquiry />} /> */}

          {/* Protected Route - Enquiry */}
          <Route element={<ProtectedRoute />}>
            <Route path="/home" element={<Home />} />

            {/* Role-Based Routes */}
            {/* Add more role-based routes as needed */}
          </Route>
        </Route>
      </Routes>
    </div>
  );
};
export default RoutePath;
